import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { IntegrationElementsEffects } from './store/elements/elements.effects';
import {
  IntegrationElementsNamespace,
  IntegrationElementsReducer,
} from './store/elements/elements.store';
import { EnabledIntegrationKindsEffects } from './store/enabled-integrations-kinds/enabled-integration-kinds.effects';
import {
  EnabledIntegrationKindsConfigToken,
  EnabledIntegrationKindsNamespace,
  EnabledIntegrationKindsReducer,
} from './store/enabled-integrations-kinds/enabled-integration-kinds.store';
import { IntegrationFeatureFlagsEffects } from './store/feature-flags/feature-flags.effects';
import {
  IntegrationsFeatureFlagsConfigToken,
  IntegrationsFeatureFlagsNamespace,
  IntegrationsFeatureFlagsReducer,
} from './store/feature-flags/feature-flags.store';
import { IntegrationAbilitiesEffects } from './store/integrations-abilities/integration-abilities.effects';
import {
  IntegrationAbilitiesNamespace,
  IntegrationAbilitiesReducer,
} from './store/integrations-abilities/integration-abilities.store';

@NgModule({
  imports: [
    StoreModule.forFeature(
      EnabledIntegrationKindsNamespace,
      EnabledIntegrationKindsReducer,
      EnabledIntegrationKindsConfigToken,
    ),
    StoreModule.forFeature(IntegrationAbilitiesNamespace, IntegrationAbilitiesReducer),
    StoreModule.forFeature(IntegrationElementsNamespace, IntegrationElementsReducer),
    StoreModule.forFeature(
      IntegrationsFeatureFlagsNamespace,
      IntegrationsFeatureFlagsReducer,
      IntegrationsFeatureFlagsConfigToken,
    ),
    EffectsModule.forFeature([
      EnabledIntegrationKindsEffects,
      IntegrationAbilitiesEffects,
      IntegrationElementsEffects,
      IntegrationFeatureFlagsEffects,
    ]),
  ],
})
export class IntegrationsDataModule {}
